import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';
import { useTheme, getThemeColors } from '../contexts/ThemeContext';
import Section from './Section';
import Button from './Button';

const CTABanner = () => {
  const { isDarkMode } = useTheme();
  const colors = getThemeColors(isDarkMode);
  return (
    <Section background="default" className="relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-400 to-primary-600"></div>
      
      {/* Pattern Overlay */}
      <div className="absolute inset-0 steel-texture opacity-20"></div>
      
      {/* Content */}
      <motion.div
        className="relative z-10 text-center"
        variants={fadeInUp}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
      >
        <h2 className={`text-3xl lg:text-4xl font-bold font-orbitron mb-6 ${isDarkMode ? 'text-black' : 'text-white'}`}>
          Ready to build with precision steel?
        </h2>
        <p className={`text-lg mb-8 max-w-2xl mx-auto ${isDarkMode ? 'text-black/80' : 'text-white/90'}`}>
          Join hundreds of satisfied customers who trust Julfikar Steel for their 
          construction and fabrication needs. Get your quote today.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            variant="primary" 
            size="lg"
            className={`!border-none !shadow-[0_8px_32px_rgba(247,148,29,0.4)] hover:!shadow-[0_12px_40px_rgba(247,148,29,0.6)] !transform hover:!-translate-y-1 !transition-all !duration-300 font-bold ${
              isDarkMode 
                ? '!bg-primary-400/90 !text-black hover:!bg-primary-400' 
                : '!bg-primary-500/90 !text-white hover:!bg-primary-500'
            }`}
            magnetic={true}
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Get Your Quote Now
          </Button>
          <Button 
            variant="secondary" 
            size="lg"
            className={`!border-none !shadow-[0_8px_32px_rgba(247,148,29,0.3)] hover:!shadow-[0_12px_40px_rgba(247,148,29,0.5)] !transform hover:!-translate-y-1 !transition-all !duration-300 font-semibold backdrop-blur-sm ${
              isDarkMode 
                ? '!bg-neutral-800/80 !text-white hover:!bg-neutral-700/90' 
                : '!bg-white/80 !text-black hover:!bg-white/95'
            }`}
            onClick={() => document.querySelector('#capabilities')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Explore Our Capabilities
          </Button>
        </div>
      </motion.div>
    </Section>
  );
};

export default CTABanner;